import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Tutorials = () => {
  return (
    <React.Fragment>
      <SEO title="Tutorials | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Tutorials"
        content="The Conference"
        contentTwo="Tutorials"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <h3>ICSI 2026 Call for Tutorial Proposals</h3>
          <p align="justify">
            ICSI 2026 technical program will include tutorial sessions. Their
            aim is to provide a fast introduction to some topics of interest to
            the swarm intelligence community.
          </p>
          <p align="justify">
            Prospective organizers of tutorial sessions should submit proposals
            indicating:
          </p>
          <p align="left">
            * Title of the tutorial.
            <br />
            * Rationale of the need for the tutorial at ICSI.
            <br />
            * Short biography and recent photo of the organizers.
            <br />
          </p>
          <p align="justify">
            Proposals are due on or before February 20th, 2026 and should be
            sent via e-mail (in either pdf or plain ASCII text form) to ICSI
            2026 secretariat at{" "}
            <a href="mailto:icsi2026@iasei.org">icsi2026@iasei.org</a>.
          </p>
          <p align="justify">
            Notification of acceptance will be sent to the organizers no later
            than Feb 28, 2026.
          </p>

          <br />
          <hr />
          <br />

          <h3>
            Tutorial 1: &quot;Multi-Scale Swarm Intelligence and
            Meta-Evolutionary Computation: A Unified Perspective&quot;
          </h3>
          <p align="justify">
            In this tutorial for ICSI 2026, the presenters will introduce the
            history and recent advances of multi-scale swarm intelligence (MSSI)
            and meta-evolutionary computation (MEC). After a brief overview of
            biological backgrounds and motivations for swarm intelligence (SI)
            and evolutionary computation (EC), the tutorial will discuss main
            design principles for the development and extension of SI and EC
            algorithms. Particular emphasis will be placed on the advantages and
            disadvantages of meta-diversity and multi-level mechanisms implied
            in these paradigms. Finally, the presenters will share their own
            research results on MSSI and MEC, including works published in
            venues such as TPDS, ASOC, PPSN, GECCO and ICSI, mainly from a
            distributed computing perspective.
          </p>

          <p>
            <h4>Content</h4>
          </p>
          <p align="justify">
            The tutorial will cover (but is not limited to) the following
            topics:
            <br />
            1. Bio introduction to the five presenters (from four universities).
            <br />
            2. Introduction to the brief history and some representative
            researchers in the area.
            <br />
            3. Presentation of biological backgrounds (e.g., multi-level track
            emergence (MTE) and multi-level selection (MLS)).
            <br />
            4. Discussion of possible motivations for validating scientific
            hypotheses.
            <br />
            5. Introduction to main design principles for possible extensions to
            swarm intelligence and evolutionary algorithms.
            <br />
            6. Discussion of meta-diversity, meta-training and multi-level
            mechanisms implied in MSSI and MEC.
            <br />
            7. Presentation of recent research papers on MSSI and MEC from a
            distributed computing perspective.
            <br />
            8. Discussion of a unified perspective and future work on
            multi-scale swarm intelligence and meta-evolutionary computation.
          </p>

          <p>
            <h4>Planned Time and Level</h4>
          </p>
          <p align="justify">
            This tutorial is planned to be completed within 1 hour (60 minutes) and is intended for an introductory audience.
          </p>


          <p>
            <h4>Presenters</h4>
          </p>
          <p align="justify">
            <b>Qiqi Duan</b> is currently a Lecturer at the School of Computing
            and Artificial Intelligence, Jiangxi University of Finance and
            Economics, Nanchang, Jiangxi, China. He obtained his Ph.D. degree
            from Harbin Institute of Technology (HIT), China, in a joint program
            with Southern University of Science and Technology (SUSTech),
            Shenzhen, Guangdong, China. His research interests include
            evolutionary algorithms—particularly meta-evolution and distributed
            evolutionary algorithms—and multi-scale swarm intelligence, in
            particular particle swarm optimization, ant colony optimization and
            swarming of AI agents. He has published related papers in JMLR,
            TPDS, TMLR, TEVC, ASOC, PPSN, GECCO, CEC, SSCI and other
            representative venues, and serves as PC member for IJCAI 2026, PPSN
            2026 and ALIFE 2026, as well as reviewer for several international
            journals.
          </p>
          <p align="justify">
            <b>Lijun Sun</b> is an Assistant Professor at Shenzhen Technology
            University, Shenzhen, Guangdong, China, and an Associate Editor of
            the International Journal of Swarm Intelligence Research (IJSIR).
            She received her Ph.D. degree from the University of Technology
            Sydney, Australia. Her research interests include multi-robot
            coordination, motion planning and decision-making algorithms.
          </p>
          <p align="justify">
            <b>Sanqian Li</b> is a Lecturer at the School of Computing and
            Artificial Intelligence, Jiangxi University of Finance and
            Economics, Nanchang, Jiangxi, China. She received her Ph.D. degree
            from the Department of Computer Science and Engineering, Southern
            University of Science and Technology (SUSTech), Shenzhen, China. Her
            research interests include ophthalmic AI, low-level image
            processing, medical image processing and multi-agent systems
            including swarm intelligence, with publications in TIP, TCSVT,
            JBHI, SPL, MICCAI, ICASSP, MIDL and other major venues.
          </p>
          <p align="justify">
            <b>Qingquan Zhang</b> is currently pursuing the Ph.D. degree at
            Southern University of Science and Technology (SUSTech), Shenzhen,
            Guangdong, China. His main research interests include fair machine
            learning, procedural content generation and multi-objective
            optimization, with works published in IEEE TEVC, IEEE TAI, SWEC and
            related journals, and he also serves as a reviewer for KBS.
          </p>
          <p align="justify">
            <b>Yang Shen</b> is currently pursuing the Ph.D. degree at the
            University of Technology Sydney, Australia, in a joint program with
            Southern University of Science and Technology (SUSTech), Shenzhen,
            Guangdong, China. His research focuses on artificial intelligence
            and its applications in swarm intelligence and multi-agent systems.
          </p>


          {/* <p>
  <h4>Presenters</h4>
</p>

<p align="justify">
  <b>Qiqi Duan</b>, Jiangxi University of Finance and Economics. Research interests include meta-evolutionary computation, distributed evolutionary algorithms, and multi-scale swarm intelligence.
</p>

<p align="justify">
  <b>Lijun Sun</b>, Shenzhen Technology University. Research interests include multi-robot coordination, motion planning, and decision-making algorithms.
</p>

<p align="justify">
  <b>Sanqian Li</b>, Jiangxi University of Finance and Economics. Research interests include medical image processing, ophthalmic AI, and swarm intelligence.
</p>

<p align="justify">
  <b>Qingquan Zhang</b>, Southern University of Science and Technology. Research interests include fair machine learning, procedural content generation, and multi-objective optimization.
</p>

<p align="justify">
  <b>Yang Shen</b>, University of Technology Sydney. Research interests focus on artificial intelligence and its applications in swarm intelligence and multi-agent systems.
</p> */}

          <p>&nbsp;</p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Tutorials;
